import { Link, createSearchParams } from 'react-router';

import { RaceTime as RaceTimeType } from '../../../../types/apiResponses';
import { formatTimeString } from '../../../../types/raceTypes';

interface RaceTimeProps {
	raceTime: RaceTimeType;
}

export default function RaceTime({ raceTime }: RaceTimeProps) {
	const racer = raceTime.racers[0];
	const ms = racer?.timeMs ?? 0;
	const isVerified = racer?.isVerified ?? false;
	const { raceNumber } = raceTime;
	const racesTo = {
		pathname: '/races',
		search: createSearchParams({
			raceType: 'blindKaizo',
			focusRace: String(raceNumber),
		}).toString(),
	};

	return (
		<tr>
			<td>
				<Link className="raceNumberLink" to={racesTo}>
					{raceNumber}
				</Link>
			</td>
			<td>{raceTime.name}</td>
			<td>{raceTime.difficulty}</td>
			<td>
				{formatTimeString(ms)}
				{!isVerified ? '*' : ''}
			</td>
		</tr>
	);
}
